import { render, staticRenderFns } from "./DevicePagesHeader.vue?vue&type=template&id=6a8e1388&scoped=true&lang=pug"
import script from "./DevicePagesHeader.vue?vue&type=script&lang=js"
export * from "./DevicePagesHeader.vue?vue&type=script&lang=js"
import style0 from "./DevicePagesHeader.vue?vue&type=style&index=0&id=6a8e1388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e1388",
  null
  
)

export default component.exports